import {
  QueryFunction,
  QueryKey,
  useQuery,
  UseQueryOptions,
} from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { FieldsApiService } from 'features/fields';
import { Field } from 'types';

import { fieldsQueryKeys } from './query-keys';

const { getField } = FieldsApiService();

const getFieldQuery = (
  id: string,
  options?: UseQueryOptions<Field>,
): {
  queryKey: QueryKey;
  queryFn: QueryFunction<Field>;
  options?: UseQueryOptions<Field>;
} => ({
  queryKey: fieldsQueryKeys.detail(id),
  queryFn: ({ signal }) => getField(id, { config: { signal } }),
  ...options,
});

export const useGetField = (id: string, options?: UseQueryOptions<Field>) => {
  const { message } = App.useApp();

  return useQuery<Field, Error>(
    getFieldQuery(id, {
      onError: (error: unknown) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      ...options,
    }),
  );
};
